import React, { useRef, useState, useEffect } from 'react';
import { useDrop } from 'react-dnd';
import CustomSectionTemplate from '../../../Pages/Library/DPP/Library/TemplateComponent/CustomSectionTemplate';
import { getControlStyle } from '../../helper';
import { useDPPState } from '../../../Pages/Library/DPP/Context/index';

function DraggableItemForCustom({
  index,
  dppEle,
  onChange,
  deleteItem,
  editingInput,
  moveCard,
  hideCustomSection,
  parentIndex,
  handleDrop,
  setDppState,
  dppState,
}) {
  const controlRef = useRef(null);
  const [{ isOverSectionChild }, drop] = useDrop({
    accept: 'item',
    drop: (item, monitor) => {
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) {
        return;
      }

      handleDrop(item, monitor, 'section', index);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOverSectionChild: monitor.isOver({ shallow: true }),
    }),
  });

  return (
    <div ref={drop(controlRef)} className="dpp-item">
      {isOverSectionChild && <div className="dpp-drag-placeholder">Drop here</div>}
      <CustomSectionTemplate
        fromForm
        key={index}
        dppEle={dppEle}
        onChange={onChange}
        deleteItem={(dataIndex) => deleteItem(dataIndex, parentIndex)}
        editingInput={(dataIndex) => editingInput(dataIndex, parentIndex)}
        dataIndex={index}
        id={dppEle?.id}
        keys={dppEle?.key}
        moveCard={moveCard}
        dppAddEditAccess
        onClick={() => {}}
        hideCustomSection={hideCustomSection}
        setDppState={setDppState}
        expColl={dppState}
      />
    </div>
  );
}

export function CustomSection(props) {
  const { setDppState, dppState } = useDPPState();
  const { editPopup } = dppState;
  const refForChild = useRef(null);
  const {
    fromForm,
    title,
    parentIndex,
    moveCard,
    otherConfiguration,
    handleChildDrop,
    editingCustomInput,
    editingInput,
    deleteCustomSectionItem,
    deleteItem,
    sectionId,
    subHeaderTitle,
  } = props;
  const onChange = () => {};
  const [expColl, toggleDrop] = useState(false);

  useEffect(() => {
    if (props?.navigateId === 'finer-details-id') {
      toggleDrop(true);
      setDppState((otherStates) => ({
        ...otherStates,
        navigateId: null,
      }));
    }
  }, [props?.navigateId]);

  const handleDrop = (item, monitor, targetId, childIndex) => {
    if (editPopup) {
      setDppState((oldData) => ({
        ...oldData,
        editPopup: false,
        editpopupData: null,
        editPopupItemIndex: -1,
        editCustomSectionIndex: -1,
      }));
    }
    handleChildDrop(item, monitor, targetId, parentIndex, childIndex);
  };

  const shouldRestrictDrop = (item) => {
    return ['digital_asset', 'product_journey', 'product_impact', 'navigation', 'custom_section'].includes(item.key);
  };

  const [{ isOverSectionParent }, dropChild] = useDrop({
    accept: 'item',
    drop: (item, monitor) => {
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset || shouldRestrictDrop(item)) {
        return;
      }

      handleDrop(item, monitor, 'section', null);
    },
    collect: (monitor) => ({
      isOverSectionParent: monitor.isOver({ shallow: true }),
    }),
  });
  const combinedStyles = getControlStyle(otherConfiguration, 'alignment', 'colour', 'bold');
  const renderToggleIcon = () => {
    return <span className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${expColl ? 'rotated' : ''}`} onClick={() => toggleDrop(!expColl)} />;
  };
  return (
    <div className="custom-section-control" id={sectionId}>
      <div className="common-custom-card card">
        <div className="card-header">
          <div className="d-flex align-items-center" style={combinedStyles}>
            <h3 className="main-title d-flex align-items-center">
              <span className="flex-fill">{title || 'Custom Section'}</span>
              {renderToggleIcon()}
            </h3>
            {fromForm && (
              <div className="action-btns ml-auto">
                <button aria-label="Edit" type="button" className="btn btn-border ml-auto py-0 px-1" onClick={() => editingInput(parentIndex)}>
                  <span className="icon-Edit-1 f-20" />
                </button>
                <button aria-label="Delete" type="button" className="btn btn-border ml-auto py-0 px-1" onClick={() => deleteItem(parentIndex)}>
                  <span className="icon-Delete f-20" />
                </button>
              </div>
            )}
          </div>
        </div>

        {expColl && (
          <div ref={dropChild(refForChild)} className="card-body" style={{ minHeight: '300px' }}>
            <p className="f-16" style={getControlStyle(otherConfiguration, 'subHeaderAlign', 'subHeaderColor', 'subHeaderBold')}>
              {subHeaderTitle}
            </p>
            {props?.controls?.map((dppEle, index) => {
              return (
                <DraggableItemForCustom
                  fromForm
                  key={dppEle?.id}
                  dppEle={dppEle}
                  onChange={onChange}
                  deleteItem={(dataIndex) => deleteCustomSectionItem(dataIndex, parentIndex)}
                  editingInput={(dataIndex) => editingCustomInput(dataIndex, parentIndex)}
                  index={index}
                  id={dppEle?.id}
                  keys={dppEle?.key}
                  moveCard={moveCard}
                  dppAddEditAccess
                  onClick={() => {}}
                  hideCustomSection={isOverSectionParent}
                  handleDrop={handleDrop}
                  setDppState={setDppState}
                  dppState={dppState}
                />
              );
            })}

            {isOverSectionParent && <div className="dpp-drag-placeholder">Drop here placeholder</div>}
          </div>
        )}
      </div>
    </div>
  );
}
export default CustomSection;
